import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Button, Alert, Spinner } from 'react-bootstrap'
import { ContentArea } from '../../components/Page/logix2020/ContentArea'
import { Subheader } from '../../components/Page/logix2020/Subheader'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import WithdrawalTable from '../../components/Withdrawals/WithdrawalTable'
import StorehouseChangeModal from '../../components/Withdrawals/StorehouseChangeModal'
import { useWithdrawalsState } from '../../stores/WithdrawalsProvider'
import useStores from '../../stores/useStore'
import { useTranslation } from 'react-i18next'
import BigFooter from '../../components/Footer/BigFooter'
import { OverlayLeft } from '../../components/Page/logix2020/OverlayLeft'
import OverlayLeftFilter from '../../components/Withdrawals/OverlayLeftFilter'
import ActiveTableFilters from '../../components/Withdrawals/ActiveTableFilters'
import ModalComponent from '../../components/Modals/ModalComponent'
import { Observer } from 'mobx-react'

const StyledContentArea = styled(ContentArea)`
  width: 100%;
  padding: 20px 30px 20px 36px;
  .control-row {
    display: felx;
    flex-wrap: wrap;
    align-items: baseline;
  }
  @media (max-width: 767px) {
    .mobileButton {
      width: 100%;
      margin-bottom: 10px;
    }
    padding: 20px;
    .control-row {
      display: block;
      flex-wrap: nowrap;
      align-items: stretch;
    }
  }
  .filterSpaceBetween {
    @media only screen and (min-width: 768px) {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
  }
`

const WithdrawalPageContent = () => {
    const {
        handleLocalChangeCheckbox,
        setSelectedRow,
        setShowAllWithdrawals,
        setForceReloadWithdrawals,
        showOverlayLeft,
        setShowOverlayLeft,
        resetFilter,
        updateOverlayLeftStates, unlockShippingOrder, stealLockShippingOrder,
        resetSO, setResetSO, resetShippingOrder, selectedSOId, getSourceStorehouseId, unLockSO, setUnLockSO, getShippingOrder,
        setSelectedSOId, setChangeSourceStorehouse, setDeleteSO, changeSourceStorehouse, deleteSO, deleteShippingOrder
    } = useWithdrawalsState()
    const { t } = useTranslation()
    const onRowClick = (e, row) => {
        setSelectedRow((prev) => (prev === row ? false : row))
        handleLocalChangeCheckbox(row.id)
    }
    const handleCloseOverlayLeft = (e) => {
        setShowOverlayLeft(false)
        updateOverlayLeftStates()
    }
    useEffect(() => {
        const init = async () => {
            setForceReloadWithdrawals(true)
        }
        init()
    }, [setForceReloadWithdrawals])

    const getUnlockTitle = () => {
        let lockInfo = getShippingOrder(selectedSOId).lockInfo;
        if (!!lockInfo?.lockedByUser) return t('withdrawalPage:unlockTitle')
        return t('withdrawalPage:stealLockTitle')
    }
    const getUnlockBody1 = () => {
        let lockInfo = getShippingOrder(selectedSOId).lockInfo;
        return `${t('withdrawalsTable:lockedBy')} ${lockInfo?.creator?.displayName}`
    }
    const getUnlockBody2 = () => {
        let lockInfo = getShippingOrder(selectedSOId).lockInfo;
        return (!!lockInfo?.lockedByUser) ? t('withdrawalPage:unlockBody') : t('withdrawalPage:stealLockBody')
    }
    const triggerStealOrUnlockShippingOrder = () => {
        let lockInfo = getShippingOrder(selectedSOId).lockInfo;
        if (!!lockInfo?.lockedByUser) unlockShippingOrder(selectedSOId)
        else stealLockShippingOrder(selectedSOId)
    }
    return (<Observer>{() => (
        <div>
            <Subheader className='subHeader-v1'>
                <div className='subheader-title flex-grow-1'>
                    {t('withdrawalPage:withdrawal')}
                </div>
            </Subheader>
            <OverlayLeft
                className={`overlay-variant ${showOverlayLeft ? 'visible' : ''}`}
            >
                <div className='header' onClick={handleCloseOverlayLeft}>
                    <span onClick={handleCloseOverlayLeft}>
                        <i className='close-icon' />
                    </span>
                    <span className='header-title'>{t('filter')}</span>
                </div>
                <div className='body'>
                    <OverlayLeftFilter />
                </div>
            </OverlayLeft>
            <StyledContentArea>
                <div className='filterSpaceBetween'>
                    <div className='control-row'>
                        <Button
                            variant='secondary'
                            className='mobileButton'
                            onClick={() => {
                                setShowOverlayLeft((prev) => !prev)
                            }}
                        >
                            {t('allFilters')}
                        </Button>
                    </div>
                    <div className='control-row'>
                        <Button
                            variant='secondary'
                            className='btn-extra-padding mobileButton'
                            onClick={() => {
                                resetFilter()
                                setForceReloadWithdrawals(true)
                                setShowAllWithdrawals(true)
                            }}
                        >
                            {t('withdrawalPage:showAllWithdrawals')}
                        </Button>
                    </div>
                </div>
                <ActiveTableFilters />
                <WithdrawalTable onRowClick={onRowClick} tableId='Withdrawal' />
            </StyledContentArea>
            {deleteSO && (
                <ModalComponent
                    ModalTitle={t('withdrawalPage:deleteShippingOrderTitle')}
                    functionButton1={() => deleteShippingOrder()}
                    textButton1={t('delete')}
                    variantButton1='danger'
                    variantBody='alert-danger'
                    BodyPart1={t('withdrawalPage:deleteShippinigOrderBody')}
                    functionCancel={() => {
                        setSelectedSOId(null)
                        setDeleteSO(null)
                    }}
                />
            )}
            {resetSO && (
                <ModalComponent
                    ModalTitle={t('withdrawalPage:resetShippingOrderTitle')}
                    functionButton1={() => resetShippingOrder()}
                    textButton1={t('yes')}
                    variantButton1='danger'
                    variantBody='alert-danger'
                    BodyPart1={t('withdrawalPage:resetShippinigOrderBody')}
                    functionCancel={() => {
                        setSelectedSOId(null)
                        setResetSO(null)
                    }}
                />
            )}
            {changeSourceStorehouse && (
                <StorehouseChangeModal
                    shippingOrderId={selectedSOId}
                    storehouseId={getSourceStorehouseId(selectedSOId)}
                    handleClose={(submit) => {
                        setSelectedSOId(null)
                        setChangeSourceStorehouse(null)
                        if (submit) setForceReloadWithdrawals(true)
                    }}
                />
            )}
            {unLockSO  && (
                <ModalComponent
                    ModalTitle={getUnlockTitle()}
                    functionButton1={() => triggerStealOrUnlockShippingOrder()}
                    textButton1={t('yes')}
                    variantButton1='danger'
                    variantBody='alert-danger'
                    BodyPart1={getUnlockBody1()}
                    BodyPart2={getUnlockBody2()}
                    functionCancel={() => {
                        setSelectedSOId(null)
                        setUnLockSO(null)
                    }}
                />
            )}
            <BigFooter />
        </div>
    )}</Observer>)
}

const WithdrawalPage = () => {
    const { uiStore } = useStores()
    const { t } = useTranslation()

    return (<Observer>{() => (
        <>
            {!uiStore.dashboard || !uiStore.allowPickingProcess ? (
                <>
                    <Subheader className='subHeader-v1'>
                        <div className='subheader-title'>
                            {t('withdrawalPage:withdrawal')}
                        </div>
                    </Subheader>
                    {!!uiStore.dashboard ? (
                        <Alert variant='danger'>{t('withdrawalPage:accessDenied')}</Alert>
                    ) : (
                        <div className='d-flex align-items-center justify-content-center'>
                            <Spinner animation='border' variant='primary' />
                        </div>
                    )}
                </>
            ) : (
                <WithdrawalPageContent />
            )}
        </>
    )}</Observer>)
}
export default WithdrawalPage
